import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings, FiX, FiKey, FiBox, FiSave, FiInfo } = FiIcons;

const SettingsModal = ({ isOpen, onClose, onSave, initialSettings }) => {
  const [settings, setSettings] = useState(initialSettings);

  useEffect(() => {
    setSettings(initialSettings);
  }, [initialSettings, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="absolute inset-0 bg-stone-900/40 backdrop-blur-sm"
      />
      <motion.div
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 20 }}
        className="relative bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden"
      >
        <div className="p-6 border-b border-stone-100 flex justify-between items-center bg-orange-50/50">
          <div className="flex items-center gap-2 font-bold text-stone-800">
            <SafeIcon icon={FiSettings} className="text-orange-600" />
            <span>API Configuration</span>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white rounded-full transition-colors">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-stone-700 flex items-center gap-2">
              <SafeIcon icon={FiKey} className="text-orange-500" />
              OpenRouter API Key
            </label>
            <input
              type="password"
              value={settings.apiKey}
              onChange={(e) => setSettings({ ...settings, apiKey: e.target.value })}
              placeholder="sk-or-v1-..."
              className="w-full px-4 py-3 rounded-xl border border-stone-200 focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 outline-none transition-all"
            />
            <p className="text-[10px] text-stone-400 flex items-center gap-1">
              <SafeIcon icon={FiInfo} /> Keys are stored locally in your browser.
            </p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-stone-700 flex items-center gap-2">
              <SafeIcon icon={FiBox} className="text-orange-500" />
              Model ID
            </label>
            <input
              type="text"
              value={settings.model}
              onChange={(e) => setSettings({ ...settings, model: e.target.value })}
              placeholder="e.g., anthropic/claude-3.5-sonnet"
              className="w-full px-4 py-3 rounded-xl border border-stone-200 focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 outline-none transition-all"
            />
            <p className="text-[10px] text-stone-400">
              Popular: <code className="bg-stone-100 px-1">openai/gpt-4o</code>, <code className="bg-stone-100 px-1">google/gemini-pro-1.5</code>
            </p>
          </div>

          <button
            onClick={() => onSave(settings)}
            className="w-full py-4 bg-stone-900 text-white rounded-2xl font-bold hover:bg-stone-800 transition-all flex items-center justify-center gap-2 shadow-lg shadow-stone-200"
          >
            <SafeIcon icon={FiSave} />
            Save Configuration
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default SettingsModal;